import { PHONE_DISPLAY, PHONE_TEL } from "@/components/shared";

export default function Footer() {
  return (
    <footer className="border-t border-[#d4af37]/15 py-12 px-6 bg-[#070709] text-xs font-mono text-zinc-500" data-testid="site-footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="/logo-wordmark.png" alt="DuroTech28 — Technology & Business Solutions" className="h-12 w-auto" data-testid="footer-logo" />
        </div>
        <div className="flex flex-wrap gap-6 text-zinc-400">
          <span>Dallas–Fort Worth Metroplex</span>
          <a href={PHONE_TEL} data-testid="footer-call-link" className="hover:text-[#d4af37] transition-colors">{PHONE_DISPLAY}</a>
        </div>
        <div>
          <span>&copy; DuroTech28. One System. Complete Solutions.</span>
        </div>
      </div>
    </footer>
  );
}
